<template>
  <div class="service">
    <v-container style="max-width: 800px">
      <v-row>
        <v-col>
          <h1>Arbetsorder</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p>
            Företaget AB
            <br />Företagsvägen 1
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h2>Plocklista</h2>
          <v-checkbox label="Kaffebönor" />
          <v-checkbox label="Rengöringskit" />
          <v-checkbox label="Avkalkningsmedel" />
        </v-col>
      </v-row>
      <v-divider style="margin: 1em" />
      <v-row v-for="c in cards" :key="c.title">
        <v-col>
          <h2>{{ c.title }}</h2>
          <v-treeview dense selectable :items="c.items" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    cards: [
      {
        title: "Bottenvåning - Kök",
        items: [
          {
            id: 1,
            name: "Avkalka",
            children: [
              {
                id: 11,
                name: "Starta maskinen",
              },
              {
                id: 12,
                name: "Töm vattenbehållaren",
              },
              {
                id: 13,
                name: "Fyll på avkalkningsmedel",
              },
              {
                id: 14,
                name: "Fyll på vatten",
              },
              {
                id: 15,
                name: "Starta avkalkning",
              },
            ],
          },
          {
            id: 2,
            name: "Rengör",
            children: [ { name: "..." }]
          },
          {
            id: 3,
            name: "Fyll på vatten",
            children: [ { name: "..." }]
          },
          {
            id: 4,
            name: "Fyll på bönor",
            children: [ { name: "..." }]
          },
        ],
      },
      {
        title: "Bottenvåning - Konferens",
        items: [
          { name: "Rengör", children: [ { name: "..." }] },
          { name: "Fyll på vatten", children: [ { name: "..." }] },
          { name: "Fyll på bönor", children: [ { name: "..." }] },
        ],
      },
      {
        title: "Våning 2 - Kök",
        items: [
          { name: "Rengör", children: [ { name: "..." }] },
          { name: "Fyll på vatten", children: [ { name: "..." }] },
          { name: "Fyll på bönor", children: [ { name: "..." }] },
        ],
      },
    ],
  }),
  created() {
    let previous = { state: true };
    for (const step of this.steps) {
      step.previous = previous;
      previous = step;
    }
  },
};
</script>
